import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import { Button, Card, FormSection } from '@ksyos/design-system';
import { useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { formatString } from '@common/utils/formatString';
import { FormParagraphFormGroupField } from '@frontend/components/fields/FormParagraphField';
import { ServiceOrganizationSettingStopModal } from '@frontend/components/pages/organizations/serviceSettings/ServiceOrganizationSettingStopModal';
import { getSelectedLanguage } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import { useServiceOrganizationSettingContext } from '@frontend/utils/hooks/useServiceOrganizationsSettingsContext';

export function ServiceOrganizationSettingStatus(): JSX.Element {
    const { reloadServiceOrganizationSettings, serviceOrganizationSetting } = useServiceOrganizationSettingContext();
    const { endDate, service, startDate } = serviceOrganizationSetting;
    const [isStopServiceModalVisible, setIsStopServiceModalVisible] = useState(false);
    const canEdit = hasOneAuthorization(ManagerAuthorization.organizationAddEdit);
    const languageFile = getSelectedLanguage();

    return (
        <Card>
            <Card.Header title={languageFile.common.status} />
            <Card.Body>
                <FormSection>
                    <FormParagraphFormGroupField
                        label="common.activeSince"
                        value={DateTime.from(startDate).format('DD-MM-YYYY')}
                    />
                    <FormParagraphFormGroupField
                        label="common.activeUntil"
                        value={endDate ? DateTime.from(endDate).format('DD-MM-YYYY') : '-'}
                    />
                </FormSection>
            </Card.Body>
            <Card.Footer>
                {!serviceOrganizationSetting.endDate && canEdit && (
                    <>
                        <Button
                            onClick={() => setIsStopServiceModalVisible(true)}
                            variant="link"
                        >
                            {formatString(languageFile.service.stopService, { 0: service.name })}
                        </Button>
                        {isStopServiceModalVisible && (
                            <ServiceOrganizationSettingStopModal
                                onClose={() => setIsStopServiceModalVisible(false)}
                                organizationName={serviceOrganizationSetting.organization.name}
                                reloadServiceOrganizationSetting={reloadServiceOrganizationSettings}
                                serviceOrganizationSettingIds={[serviceOrganizationSetting.id]}
                                serviceOrServiceGroupOrCarePathName={serviceOrganizationSetting.service.name}
                                startDate={serviceOrganizationSetting.startDate}
                            />
                        )}
                    </>
                )}
            </Card.Footer>
        </Card>
    );
}
